export default class {
  static isInTrello() {
    const location = window.location
    if (location.hash || location.ancestorOrigins.length > 0) {
      return true
    }
    return false
  }
}
